<mdi [name]="icon"></mdi>
<div class="badge" *ngIf="badgeNumber">{{ badgeNumber }}</div>
